/* js/components/SpotMarkerLibre.svelte generated by Svelte v3.46.4 */
import {
	SvelteComponent,
	attr,
	binding_callbacks,
	detach,
	element,
	init,
	insert,
	listen,
	noop,
	safe_not_equal,
	src_url_equal,
	toggle_class
} from "svelte/internal";

import { onMount, onDestroy } from 'svelte';

// import mapboxgl from "mapbox-gl";
import maplibregl from 'maplibre-gl';

import { getContext, createEventDispatcher } from 'svelte';
import { appRouter } from '../appRouter.js';
import { key } from '../maplibre.js';
import { genevaCoords, createGeoJSONCircle } from '../geoUtils.js';

function create_fragment(ctx) {
	let img;
	let img_src_value;
	let img_style_value;
	let mounted;
	let dispose;

	return {
		c() {
			img = element("img");
			if (!src_url_equal(img.src, img_src_value = appRouter.normalizePath(/*url*/ ctx[4]))) attr(img, "src", img_src_value);
			attr(img, "style", img_style_value = `z-index:${/*zIndex*/ ctx[0]}`);
			attr(img, "class", "spot-marker svelte-jvx1gu");
			attr(img, "alt", "spot marker");
			toggle_class(img, "spot-marker-current", /*isCurrent*/ ctx[1]);
			toggle_class(img, "clickable", /*clickable*/ ctx[2]);
		},
		m(target, anchor) {
			insert(target, img, anchor);
			/*img_binding*/ ctx[11](img);

			if (!mounted) {
				dispose = listen(img, "click", /*onClick*/ ctx[5]);
				mounted = true;
			}
		},
		p(ctx, [dirty]) {
			if (dirty & /*zIndex*/ 1 && img_style_value !== (img_style_value = `z-index:${/*zIndex*/ ctx[0]}`)) {
				attr(img, "style", img_style_value);
			}

			if (dirty & /*isCurrent*/ 2) {
				toggle_class(img, "spot-marker-current", /*isCurrent*/ ctx[1]);
			}

			if (dirty & /*clickable*/ 4) {
				toggle_class(img, "clickable", /*clickable*/ ctx[2]);
			}
		},
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(img);
			/*img_binding*/ ctx[11](null);
			mounted = false;
			dispose();
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let { coords } = $$props;
	let { id = 0 } = $$props;
	let { zIndex = 1 } = $$props;
	let { isLast = false } = $$props;
	let { isCurrent = false } = $$props;
	let { showRadius = false } = $$props;
	let { radiusMeters = 35 } = $$props;
	let { clickable = false } = $$props;
	let markerElement;
	let marker;
	const { getMap } = getContext(key);
	const map = getMap();
	const dispatch = createEventDispatcher();
	const extensionIndex = isLast ? id + 10 + 1 : id + 1;
	const indexString = extensionIndex.toString().padStart(2, 0);
	const url = `/markers/hypercity_marker-${indexString}.svg`;

	onMount(() => {
		const options = { element: markerElement, anchor: 'center' };
		marker = new maplibregl.Marker(options).setLngLat(coords).addTo(map);

		if (showRadius) {
			const radiusLayerId = `radius_${id}`;
			const radiusAsKm = radiusMeters / 1000;
			map.addSource(radiusLayerId, createGeoJSONCircle(coords, radiusAsKm));

			map.addLayer({
				"id": radiusLayerId,
				"type": "fill",
				"source": radiusLayerId,
				"layout": {},
				"minzoom": 14,
				"visibility": "visible",
				"paint": {
					"fill-color": "white",
					"fill-opacity": 0.35
				}
			});
		}
	});

	onDestroy(() => {
		if (marker) {
			// console.log("removing marker with id", id);
			marker.remove();
		}
	});

	function onClick() {
		if (clickable) {
			dispatch('requestSelection', { id });
		}
	}

	function img_binding($$value) {
		binding_callbacks[$$value ? 'unshift' : 'push'](() => {
			markerElement = $$value;
			$$invalidate(3, markerElement);
		});
	}

	$$self.$$set = $$props => {
		if ('coords' in $$props) $$invalidate(6, coords = $$props.coords);
		if ('id' in $$props) $$invalidate(7, id = $$props.id);
		if ('zIndex' in $$props) $$invalidate(0, zIndex = $$props.zIndex);
		if ('isLast' in $$props) $$invalidate(8, isLast = $$props.isLast);
		if ('isCurrent' in $$props) $$invalidate(1, isCurrent = $$props.isCurrent);
		if ('showRadius' in $$props) $$invalidate(9, showRadius = $$props.showRadius);
		if ('radiusMeters' in $$props) $$invalidate(10, radiusMeters = $$props.radiusMeters);
		if ('clickable' in $$props) $$invalidate(2, clickable = $$props.clickable);
	};

	return [
		zIndex,
		isCurrent,
		clickable,
		markerElement,
		url,
		onClick,
		coords,
		id,
		isLast,
		showRadius,
		radiusMeters,
		img_binding
	];
}

class SpotMarkerLibre extends SvelteComponent {
	constructor(options) {
		super();

		init(this, options, instance, create_fragment, safe_not_equal, {
			coords: 6,
			id: 7,
			zIndex: 0,
			isLast: 8,
			isCurrent: 1,
			showRadius: 9,
			radiusMeters: 10,
			clickable: 2
		});
	}
}

export default SpotMarkerLibre;